import { render, staticRenderFns } from "./StemdoerListSkeleton.vue?vue&type=template&id=58745dba&scoped=true"
var script = {}
import style0 from "./StemdoerListSkeleton.vue?vue&type=style&index=0&id=58745dba&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58745dba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/r1/a/_stemdoplatform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58745dba')) {
      api.createRecord('58745dba', component.options)
    } else {
      api.reload('58745dba', component.options)
    }
    module.hot.accept("./StemdoerListSkeleton.vue?vue&type=template&id=58745dba&scoped=true", function () {
      api.rerender('58745dba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/sections/shared/explore/stemdoer-list-skeleton/StemdoerListSkeleton.vue"
export default component.exports